// src/components/ui.js
import React from 'react';

// Simple Card wrapper
export function Card({ children, className = '', ...props }) {
  return (
    <div
      className={`p-4 bg-white rounded-lg shadow ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

// Simple Input component
export function Input(props) {
  return (
    <input
      {...props}
      className="border rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
    />
  );
}

// Simple Button component
export function Button({ children, className = '', ...props }) {
  return (
    <button
      {...props}
      className={`px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 ${className}`}
    >
      {children}
    </button>
  );
}
